import { NgModule } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { DetailComponent } from './detail/detail.component';
import { ListComponent } from './list/list.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SharedModule } from '../shared/shared.module';
import { EnumDropdownComponent } from './enum-dropdown/enum-dropdown.component';


@NgModule({
  declarations: [
    ListComponent,
    AlertComponent,
    DetailComponent,
    DropdownComponent,
    EnumDropdownComponent 
  ],
  imports: [
    SharedModule,
    MatProgressSpinnerModule
  ],
  exports: [
    AlertComponent
   ]
})
export class UtilsFlcModule { }
